import React, { useState, useEffect, useContext } from 'react';
import { Context } from '../../redux/store';
import Layout from '../../components/layout'
import "./about-zurnai.scss";
import { Link } from "gatsby";
import AnchorLink from '../../components/AnchorLink';
import { Col, Row } from 'react-grid-system';
// import aboutBannerVideo from '../../videos/about-zurnai-inner-banner.mp4'
// import innerBannerThumbnail from '../../images/about/about-banner-video-thumbnail.webp'
import CornerShape from '../../components/CornerShape';
import VideoBlock from '../../components/VideoBlock';
import aboutCommunityVideo from '../../videos/about-zurnai-community.mp4';
import aboutCommunityVideoMobile from '../../videos/about-zurnai-community-mobile.mp4';
import aboutCommunityThumbnail from '../../images/about/community-block-thumbnail.webp';
import CtaVideoBlock from '../../components/ctaBlocks/ctaVideoBlock';
import ctaVideo from '../../videos/cta-video.mp4';
import ctaVideoThumbnail from '../../images/about/cta-video-thumbnail.webp';
import actingInfoImg from '../../images/about/acting-info-img.webp';
import eliminationFeaturedImg from '../../images/about/elimination-featured-image.webp'
// import BannerTypeB from '../../components/banners/bannerTypeB';
import BlockTitle from '../../components/BlockTitle';
import { Seo } from '../../components/seo';
import clockIcon from "../../images/icons/5-min-alarm-clock-icon.png";

const referencesDesc = ['ZURNAI™ (nalmefene injection) Auto-Injector Full Prescribing Information. Knoa Pharma LLC; 2026.']

const AboutZurnaiPage = () => {
    const { state } = useContext(Context);

    const [videoSrc, setVideoSrc] = useState(aboutCommunityVideo);

    useEffect(() => {
        const updateVideoSource = () => {
            if (window.innerWidth < 768) {
                setVideoSrc(aboutCommunityVideoMobile); // Mobile video
            } else {
                setVideoSrc(aboutCommunityVideo); // Desktop video
            }
        };

        // Initial check on mount
        updateVideoSource();

        // Add resize listener to update video on window resize
        window.addEventListener('resize', updateVideoSource);

        // Cleanup listener on unmount
        return () => window.removeEventListener('resize', updateVideoSource);
    }, []);

    return (
        <Layout pageReference={referencesDesc} pageClass={`about-page`}>

            {/* Starts About Page Banner section */}
            {/* <BannerTypeB
                videoSrc={aboutBannerVideo}
                posterThumbnail={innerBannerThumbnail}
                portrayalText="Actor portrayals."
                gradient={true}
                videoBtn={true}
                id={'main-content'}
            /> */}
            {/* Ends About Page Banner section */}

            {/* Starts Acting Info Section */}
            <section className='block-acting-info' id='main-content'>
                <div className="curved-shape">
                    <span className="gradient-line"></span>
                </div>
                <div className="container">
                    <Row justify='between'>
                        <Col lg={6} xl={6.5}>
                            <BlockTitle
                                headingTag='h1'
                                title={`A LONG-ACTING OPTION FOR OPIOID OVERDOSE REVERSAL<sup class='footnote-link'>1</sup>*`}
                            />
                            <div className="block-acting-info__content" data-aos="fade-up">
                                <div className="top-info">
                                    <h3 className="info-title">
                                        The first and only nalmefene <span className="nobr">auto-injector</span><sup className='footnote-link'>1</sup>
                                    </h3>
                                    <p>While the duration of action of nalmefene is as long as most opioids, a recurrence of respiratory depression is possible, even after an apparently adequate initial response to ZURNAI treatment.</p>
                                    <p>Therefore, it is necessary to seek emergency medical assistance immediately after administration of the first dose of ZURNAI and to keep the patient under continued surveillance. A second dose may be necessary if there is recurrence of symptoms of opioid overdose.</p>
                                    <p>Additional supportive and/or resuscitative measures may be helpful while awaiting emergency medical assistance.</p>
                                    <p><span className='symbol'>*</span>ZURNAI mean elimination half-life of 9.07 hours is based on a pharmacokinetic study of 24 healthy adult subjects given a single dose of intramuscular ZURNAI.</p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6} xl={5.5}>
                            <div className="block-acting-info__media" data-aos="fade-up">
                                <img src={actingInfoImg} width={1218} height={1364} alt="A woman's hand holding the ZURNAI auto-injector" loading='lazy' aria-hidden="true" />
                                <div className="footnote">
                                    <p>Not actual size.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            {/* Ends Acting Info Section */}

            {/* Starts Opioid Receptors Section */}
            <section className='block-opioid-receptors'>
                <div className="container">
                    <div className="block-opioid-receptors__wrap" data-aos="fade-up">
                        <div className="wrapper-moblile-only">
                            <div className='block-opioid-receptors__icon'>
                                <img src={clockIcon} alt="Icon of a stopwatch" width={108} height={124} loading='lazy' aria-hidden="true" />
                            </div>
                            <h2 className="h3 info-title">{">"}80% of opioid receptors blocked within 5 minutes<sup className='footnote-link'>1</sup> </h2>
                        </div>
                        <div className="block-opioid-receptors__content">
                            <h2 className="h3 info-title">{">"}80% of opioid receptors blocked within 5 minutes<sup className='footnote-link'>1</sup> </h2>
                            <p>Following a 1 mg parenteral dose, nalmefene was rapidly distributed. In a pharmacology study of brain receptor occupancy, a 1 mg dose of nalmefene blocked more than 80% of brain opioid receptors within 5 minutes after administration.<sup className='footnote-link'>1</sup> </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Ends Opioid Receptors Section */}

            {/* Starts Video Community Section */}
            <section className='block-video-community'>
                <div className="block-video-community__content">
                    <div className="container">
                        <div className='inner-container block-center'>
                            <BlockTitle
                                headingTagClass='h1'
                                hasExternalLink
                                title={`ZURNAI (nalmefene injection) is designed to be used by anyone in the community`}
                                description={
                                    <>
                                        <p>See important information <br></br> about <Link to="/how-to-use-zurnai">administering ZURNAI</Link>.</p>
                                    </>
                                }
                            />
                        </div>
                    </div>
                </div>

                <CornerShape>
                    <VideoBlock
                        videoSrc={videoSrc}
                        posterThumbnail={aboutCommunityThumbnail}
                        portrayalText="Actor portrayals."
                        videoBtn={true}
                        maxHeight="594px"
                        minHeight="189px"
                        ariaLabel="Face montage video"
                    />
                </CornerShape>
            </section>
            {/* Ends Video Community Section */}

            {/* Starts Elimination Section */}
            <section className="block-elimination">
                <div className="container">
                    <Row justify='between' align='center'>
                        <Col lg={4}>
                            <div className="block-elimination__content" data-aos="fade-up">
                                <h2>9-hour mean terminal <br className='desktop-only' /> elimination half-life<sup className='footnote-link'>1</sup></h2>
                                <p>ZURNAI mean terminal elimination half-life of 9.07 hours is based on a <AnchorLink offset={state.headerHeight || 80} to="/zurnai-data/#Pharmacokinetic">pharmacokinetic study</AnchorLink> of 24 healthy adult subjects given a single dose of intramuscular ZURNAI.</p>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <div className="block-elimination__media" data-aos="fade-up">
                                <img src={eliminationFeaturedImg} width={861} height={337} alt="ZURNAI auto-injector without the cap" loading="lazy" aria-hidden="true" />
                                <div className="footnote">
                                    <p>Not actual size.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            {/* Ends Elimination Section */}

            {/* Starts CTA Video Section */}
            <CornerShape as='section' className='block-cta-video'>
                <CtaVideoBlock
                    title="Continue exploring"
                    videoSrc={ctaVideo}
                    posterThumbnail={ctaVideoThumbnail}
                    portrayalText="Actor portrayals."
                    videoBtn={true}
                    maxHeight="420px"
                    minHeight="264px"
                    firstBtnLink="/opioid-overdose-crisis/"
                    firstBtnText="Opioid overdose crisis"
                    btnClassName="btn btn-primary"
                    secondBtnText="ZURNAI data"
                    secondBtnLink="/zurnai-data"
                    thirdBtnText="Administration"
                    thirdBtnLink="/how-to-use-zurnai/"
                    className="about-cta-video"
                    ariaLabel="decorative actor portrayal video"
                />
            </CornerShape>
            {/* Ends CTA Video Section */}

        </Layout>
    )
}

export default AboutZurnaiPage;

export const Head = () => (
    <Seo
        title={'A long-acting opioid antagonist'}
        description={'ZURNAI is a long-acting opioid antagonist. The active ingredient, nalmefene, is administered through an auto-injector.'}
        keywords={'ZURNAI, Nalmefene, auto-injector, opioid overdose reversal, opioid antagonist'}
    />
);

export const defaultReferences = [
    {
        number: "1.",
        text: "ZURNAI™ (nalmefene injection) Auto-Injector"
    },
    {
        number: "2.",
        text: "Centers for Disease Control and Prevention. "
    }
];